import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Typography,
  CircularProgress,
  Grid,
  TableCell,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React, { MutableRefObject, UIEvent, useEffect, useRef } from "react";
import Surround from "./Surround";

type Props = {
  searchLen: number;
  tableHeadElement: () => JSX.Element;
  tableBodyElement: () => JSX.Element;
  isAllLoaded: boolean;
  isLoading: boolean;
  isMoreLoading: boolean;
  handleScroll: (e: UIEvent<HTMLDivElement>) => void;
  limit: number;
  total: number;
  orderListLength: number;
  isFastLoading: MutableRefObject<boolean>;
  getMoreOrderList: (searchParams: any) => Promise<void>;
  createGetListApiParams: () => any;
  noSearchElementText?: string; // データがない場合の文言
};

/**
 * @param root0   コンポーネントのプロップス
 * @returns JSX.Element
 */
function OrderTable({
  searchLen,
  tableHeadElement,
  tableBodyElement,
  isAllLoaded,
  isLoading,
  isMoreLoading,
  handleScroll,
  limit,
  total,
  orderListLength,
  isFastLoading,
  getMoreOrderList,
  createGetListApiParams,
  noSearchElementText = "該当する注文がありません。",
}: Props) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const checkScrollable = () => {
    if (containerRef.current)
      return containerRef.current?.scrollHeight > containerRef.current?.clientHeight;
    return false;
  };

  // 中のコンテンツが小さいとスクロールできず、無限ローディングさせることができないため、事前に+αで読んでおく。
  useEffect(() => {
    if (
      limit <= orderListLength &&
      orderListLength < total &&
      !isLoading &&
      !isFastLoading.current
    ) {
      if (!checkScrollable()) {
        (async () => {
          await getMoreOrderList(createGetListApiParams());
        })();
      }
    }
  }, [orderListLength, isLoading]);
  return (
    <>
      <Box
        mt={3}
        display="flex"
        flexDirection="row"
        borderBottom={4}
        borderColor="primary.main"
        justifyContent="flex-start"
      >
        <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
          <Box display="flex" flexDirection="row">
            <Box textAlign="left" display="flex" flexDirection="row" alignItems="flex-end">
              <Typography fontSize={20}>検索結果</Typography>
              <Typography fontSize={20}>&emsp;{searchLen}件</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box mt={2}>
        {/* 表 */}
        <TableContainer
          component={Paper}
          sx={{ width: "100%", minWidth: "100%", height: "calc(100vh - 180px)" }}
          onScroll={handleScroll}
        >
          <Table
            stickyHeader
            sx={{ width: "100%", borderCollapse: "separate" }}
            aria-label="order table"
          >
            <TableHead>{tableHeadElement()}</TableHead>
            {searchLen > 0 ? (
              <TableBody>{tableBodyElement()}</TableBody>
            ) : (
              <TableCell colSpan={200} sx={{ p: 10, textAlign: "center", border: "none" }}>
                {noSearchElementText}
              </TableCell>
            )}
          </Table>
          {!isAllLoaded && isMoreLoading && (
            <Box py={3} textAlign="center">
              <CircularProgress />
            </Box>
          )}
        </TableContainer>
      </Box>
    </>
  );
}

export default React.memo(OrderTable);
